module.exports = __webpack_public_path__ + "img/mannul_home_creadeQR.ff97caea.png";